module.exports = __webpack_public_path__ + "c4f94da44866644616b41452877f92e4.png";